export default "__VITE_ASSET__xAOQvRdl__"